"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/forward-all-calls`;
    }
    /**
     * Returns information about *Forward All Company Calls* feature setting.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/forward-all-calls
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadCompanyAnsweringRules
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates *Forward All Company Calls* feature setting.
     * HTTP Method: patch
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/forward-all-calls
     * Rate Limit Group: Medium
     * App Permission: EditAccounts
     * User Permission: EditCompanyAnsweringRules
     */
    async patch(forwardAllCompanyCallsInfo, restRequestConfig) {
        const r = await this.rc.patch(this.path(), forwardAllCompanyCallsInfo, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map